import React from "react";
import PaybyPaymentComplete from "../components/payby";
import AfsPaymentConfirmation from "modules/afs/afs.payment.confirmation";
import queryString from "query-string";

const PaymentConfirmation = () => {

  const queryParams = queryString.parse(window.location.search);

  return (
    <div className="store-page-popup">
      {queryParams.checkoutId ? (
        <AfsPaymentConfirmation />
      ) : 
        <PaybyPaymentComplete />
      }
    </div>
  );
};

export default PaymentConfirmation;
